import Image from "./Image";
import Picture from "./Picture";
import React from "react";
import { useBrand } from "./BrandContext";
import { useTakebackConfig } from "./TakebackConfigContext";

export const LARGE_IMAGE_SIZES = [
  { width: 1960, height: 590 },
  { width: 2520, height: 885 },
  { width: 3360, height: 1180 },
];
export const SMALL_IMAGE_SIZES = [{ width: 960, height: 400 }];
export const MOBILE_IMAGE_SIZE = { width: 800, height: 500 };

function HeaderBackgroundImage() {
  const { headerImageUrls, mobileHeaderImageUrl } = useTakebackConfig();
  const { name } = useBrand();

  let smallSrcSet;
  let largeSrcSet;

  if (headerImageUrls !== undefined) {
    const headerImageUrlsCopy = [...headerImageUrls];
    const smallImageUrls = headerImageUrlsCopy.splice(
      0,
      SMALL_IMAGE_SIZES.length
    );
    const largeImageUrls = headerImageUrlsCopy;

    smallSrcSet = smallImageUrls
      .map((url, index) => {
        return `${url} ${SMALL_IMAGE_SIZES[index].width}w`;
      })
      .join(", ");
    largeSrcSet = largeImageUrls
      .map((url, index) => {
        return `${url} ${LARGE_IMAGE_SIZES[index].width}w`;
      })
      .join(", ");
  }

  return (
    <>
      <Image
        height="100%"
        width="100%"
        objectFit="cover"
        position="absolute"
        display={[null, "none", null, null]}
        top={0}
        left={0}
        src={mobileHeaderImageUrl}
        alt={`${name} header image`}
      />
      <Picture
        height="100%"
        width="100%"
        cover
        position="absolute"
        display={["none", "initial", null, null]}
        top={0}
        left={0}
        src={headerImageUrls[headerImageUrls.length - 1]}
        alt={`${name} header image`}
        sources={[
          {
            media: "(max-width: 959px)",
            srcSet: smallSrcSet,
          },
          { media: "(min-width: 960px)", srcSet: largeSrcSet },
        ]}
      />
    </>
  );
}

export default HeaderBackgroundImage;
